

/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import colors from "assets/theme/base/colors";
import { FONT_MONO, monoTabularProps } from "styles/tokens/typography";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { text } = colors;

const bodyFontFamily = '"Hanken Grotesk", "Inter", "Helvetica", "Arial", sans-serif';

const tableCell = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(10)} ${pxToRem(16)}`,
      borderBottom: `1px solid #ECF1F8`,
      color: text.main,
      fontSize: pxToRem(14),
      lineHeight: 1.43,
    },
    head: {
      fontFamily: bodyFontFamily,
      fontWeight: 600,
      fontSize: pxToRem(12),
      textTransform: "uppercase",
      letterSpacing: "0.04em",
    },
    body: {
      fontFamily: FONT_MONO,
      fontWeight: 400,
      ...monoTabularProps,
      "& .MuiTypography-root, & span, & a": {
        fontFamily: `${FONT_MONO} !important`,
        fontWeight: 400,
        ...monoTabularProps,
      },
    },
  },
};

export default tableCell;
